import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  card: {
    padding: [theme.spacing(3), theme.spacing(4)],
    position: 'relative',
    display: 'block',
    backgroundColor: '#fff',
    color: '#111236',
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: '0 1px 3px 0 rgb(37 32 31 / 30%)',
    borderRadius: 12,
  },
}));

const Card = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.card, className)}>
      {children}
    </div>
  );
}

export default Card;